import { useMutation, useQuery } from "react-query";
import { useParams } from "react-router-dom";
import {
  reactQueryDelete,
  reactQueryGet,
  reactQueryPost,
} from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";
import { useCurrentSpaceContext } from "@circle-react/contexts";

export const useFiles = () => {
  const { lessonId } = useParams();
  const { data: space } = useCurrentSpaceContext();

  const { data, isLoading, refetch } = useQuery(
    ["lesson-files", lessonId, space?.id],
    () =>
      reactQueryGet(
        internalApi.courses.lessonFiles.index({
          courseId: space?.id,
          lessonId,
          params: {
            per_page: 20,
          },
        }),
      ),
    {
      enabled: !!lessonId && !!space,
      refetchOnWindowFocus: false,
    },
  );

  const files = isLoading ? [] : data.records;
  const count = isLoading ? 0 : data.count;

  const { mutate: addFile, isLoading: isAddingFile } = useMutation(
    signedId =>
      reactQueryPost(
        internalApi.courses.lessonFiles.index({
          courseId: space.id,
          lessonId,
        }),
        {
          file: { signed_id: signedId },
        },
      ),
    {
      onSuccess: () => {
        refetch();
      },
    },
  );

  const { mutate: removeFile, isLoading: isRemovingFile } = useMutation(
    fileId =>
      reactQueryDelete(
        internalApi.courses.lessonFiles.destroy({
          courseId: space?.id,
          lessonId,
          fileId,
        }),
      ),
    {
      onSuccess: () => {
        refetch();
      },
    },
  );

  return {
    files,
    count,
    isLoading,
    refetch,
    addFile,
    isAddingFile,
    removeFile,
    isRemovingFile,
    meta: data?.meta,
  };
};
